import { ReactNode } from 'react'

import { useStyles } from './styles'

interface IProps {
  label: string | ReactNode
  value?: string | number
  fullWidth?: boolean
  endIcon?: ReactNode
}

export const NFTTextField = ({ label, value, fullWidth, endIcon }: IProps) => {
  const classes = useStyles({ fullWidth })

  if (!value) {
    return null
  }

  return (
    <div className={classes.field}>
      <p className={classes.fieldLabel}>{label}</p>
      <div className={classes.valueWrapper}>
        <p className={classes.value}>{value}</p>
        {endIcon}
      </div>
    </div>
  )
}
